import React from 'react';
import {
 useLocation, useNavigate
} from 'react-router-dom';
import {
    LayoutDashboard,
    Cable,
    GitBranch,
    Zap,
    Shield,
    Key,
    Settings,
} from 'lucide-react';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton,
    SidebarRail,
} from 'shared/components/ui/sidebar';
import AppSwitcher from './components/AppSwitcher';
import {
 NavItem
} from './types/dataBuilderV2.types';

const mainNavItems: NavItem[] = [
    {
 title: 'Dashboard',
url: '',
icon: LayoutDashboard
},
    {
 title: 'Connections',
url: 'connections',
icon: Cable
},
    {
 title: 'Workflows',
url: 'workflows',
icon: GitBranch
},
    {
 title: 'Triggers',
url: 'triggers',
icon: Zap
},
    {
 title: 'Security',
url: 'security',
icon: Shield
},
];

const footerNavItems: NavItem[] = [
    {
 title: 'API Keys',
url: 'api-keys',
icon: Key
},
    {
 title: 'Settings',
url: 'settings',
icon: Settings
},
];

const DataBuilderV2Sidebar: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (url: string) => {
        const currentPath = location.pathname;
        if (url === '') {
            return currentPath.endsWith('data-builder-v2') || currentPath.endsWith('data-builder-v2/');
        }
        return currentPath.includes(`/data-builder-v2/${url}`);
    };

    const handleNavigate = (url: string) => {
        if (url === '') {
            navigate('.');
        } else {
            navigate(url);
        }
    };

    return (
        <Sidebar collapsible="icon">
            <SidebarHeader>
                <AppSwitcher />
            </SidebarHeader>
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>Navigation</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {mainNavItems.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton
                                        tooltip={item.title}
                                        isActive={isActive(item.url)}
                                        onClick={() => handleNavigate(item.url)}
                                    >
                                        <item.icon />
                                        <span>{item.title}</span>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
            <SidebarFooter>
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {footerNavItems.map((item) => (
                                <SidebarMenuItem key={item.title}>
                                    <SidebarMenuButton
                                        tooltip={item.title}
                                        isActive={isActive(item.url)}
                                        onClick={() => handleNavigate(item.url)}
                                    >
                                        <item.icon />
                                        <span>{item.title}</span>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    );
};

export default DataBuilderV2Sidebar;
